import { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';
import { Lightning } from '../../../assets/icon/icon';

export type SubheaderType = {
  className?: string;
  title?: string;
  icon?: ReactNode;
  iconFill?: string;
  iconSize?: number;
  onClick?: () => void;
};

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 16px;
  width: 16px;
  margin-right: 6px;
`;

const Title = styled.b`
  position: relative;
  @media screen and (max-width: 450px) {
    font-size: 19px;
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

const Body = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 20px 0px 0px;
  gap: 8px;
`;

const SubheaderRoot = styled.div`
  width: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 8px 16px;
  box-sizing: border-box;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  font-size: 24px;
  color: #1b1a1c;
  font-family: Montserrat, Arial, sans-serif;
`;

/**
 * SubHeader component for section headers with optional icons
 */
const SubHeader: FunctionComponent<SubheaderType> = ({
  className = '',
  title = 'Pillars of Strength',
  icon,
  iconFill = '#656565',
  iconSize = 16,
  onClick,
}) => {
  return (
    <SubheaderRoot className={className} onClick={onClick}>
      <Body>
        {icon ? (
          <IconWrapper>{icon}</IconWrapper>
        ) : (
          <IconWrapper>
            <Lightning fill={iconFill} size={iconSize} />
          </IconWrapper>
        )}
        <TitleWrapper>
          <Title>{title}</Title>
        </TitleWrapper>
      </Body>
    </SubheaderRoot>
  );
};

export default SubHeader;
